import apiClient from '../../services/axios';

export type PaymentOperatorAlert = {
  id: string;
  paymentWeekStart: string;
  kind: 'failed' | 'stale' | 'unexpectedly_empty' | 'overdue' | 'unreconciled';
  source: 'all' | 'mercury' | 'candid' | 'inbox';
  reasonCode: string;
  firstRunId: string;
  latestRunId: string;
  firstObservedAt: string;
  lastObservedAt: string;
  acknowledgedByUserId: string | null;
  acknowledgedAt: string | null;
  resolvedAt: string | null;
  recovery: 'source_recovered' | 'week_locked' | null;
  recoveryRunId: string | null;
};

export type PaymentOperatorAlertPage = {
  items: PaymentOperatorAlert[];
  total: number;
  unresolvedCount: number;
  unacknowledgedCount: number;
};

export const paymentOperatorAlertsApi = {
  list: (
    includeResolved: boolean,
    offset: number,
    signal?: AbortSignal
  ): Promise<PaymentOperatorAlertPage> =>
    apiClient
      .get<PaymentOperatorAlertPage>('/admin/payment-operator-alerts', {
        params: { includeResolved, offset },
        signal,
      })
      .then(({ data }) => data),
  acknowledge: (id: string): Promise<PaymentOperatorAlert> =>
    apiClient
      .post<PaymentOperatorAlert>(
        `/admin/payment-operator-alerts/${encodeURIComponent(id)}/acknowledge`
      )
      .then(({ data }) => data),
};
